import React from 'react';

export const IconCheck = () => {
  return (
    <svg
      width='10'
      height='10'
      viewBox='0 0 10 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='10' height='10' rx='5' fill='#58B52B' />
      <path d='M3 4.99805L4.53846 6.49805L7 3.49805' stroke='white' />
    </svg>
  );
};
